import {KakaoMap} from "pages/dashboard/map/kakao/KakaoMap"
import {RealDeviceInfoWindow} from "pages/dashboard/popup/RealDeviceInfoWindow"
import {observer} from "mobx-react";
import {ImpactAlarmWindow} from "pages/dashboard/popup/ImpactAlarmWindow"
import {useDashboardMap} from "pages/dashboard/map/hook/dashboardmap-hook"
import {PathTrackingWindow} from "pages/dashboard/popup/PathTrackingWindow"
import {ImpactHistoryWindow} from "pages/dashboard/popup/ImpactHistoryWindow"
import {PathTrackingChartWindow} from "pages/dashboard/popup/PathTrackingChartWindow"
import {StatusCharts} from "pages/dashboard/map/status_chart/StatusCharts"
import {useEffect} from "react";
import {NotificationType, showNotification} from "../../../common/Notification";

export const mapKey = "F1C599A5-BCBA-3315-B8E8-14574E088CD6"

export const DashboardContentPanel = observer(() => {
    const {
        devices,
        selectedDevice,
        centerLatLng,
        zoomLevel,
        showRealDeviceInfo,
        showPathTrackingInfo,
        showImpactHistory,
        setShowSelectedRealDeviceInfo,
        setShowPathTrackingInfo,
        setShowImpactHistory,
        emergencyDevices,
        showStatusChart,
        powerDisconnectedDevices
    } = useDashboardMap()

    const isShowRealDeviceInfoWindow = showRealDeviceInfo && !!selectedDevice
    const isShowImpactAlarmWindow = emergencyDevices && emergencyDevices.length > 0
    const isShowPathTrackingWindow = showPathTrackingInfo && !!selectedDevice
    const isShowImpactHistoryWindow = showImpactHistory && !!selectedDevice


    return (
        <div className="column map-body" style={{position: 'relative', display: 'block'}}>
            <KakaoMap centerPosition={centerLatLng} zoomLevel={zoomLevel} devices={devices}/>
            <RealDeviceInfoWindow
                close={() => setShowSelectedRealDeviceInfo(false)}
                show={isShowRealDeviceInfoWindow} device={selectedDevice}
            />
            <ImpactAlarmWindow show={isShowImpactAlarmWindow} close={() => {
            }} devices={emergencyDevices}/>

            {/*<ImpactAlarmWindow show={true} close={() => {*/}
            {/*}} devices={[{*/}
            {/*    address: {*/}
            {/*        address: "서울특별시 강남구 논현동 1",*/}
            {/*        subAddress: "sub"*/}
            {/*    },*/}
            {/*    id: 1,*/}
            {/*    name: "SOONSIK PARK",*/}
            {/*    mobile: {*/}
            {/*        phoneNumber: "010-1111-1111"*/}
            {/*    },*/}
            {/*    protector: {*/}
            {/*        name: "보호자",*/}
            {/*        mobile: '010-2222-2222'*/}
            {/*    },*/}
            {/*    communicationDevice: {*/}
            {/*        status: "WORKING",*/}
            {/*        eui: "12345234234",*/}
            {/*        lastCommunicationTime: "2021-01-01 12:00:00",*/}
            {/*        currentLatLng: {*/}
            {/*            lat: "37.566826",*/}
            {/*            lng: "126.9786567"*/}
            {/*        },*/}
            {/*    }*/}
            {/*}]}/>*/}
            <PathTrackingWindow
                show={isShowPathTrackingWindow} close={() => {
                setShowPathTrackingInfo(false)
            }}/>
            {isShowPathTrackingWindow && <PathTrackingChartWindow/>}
            <ImpactHistoryWindow show={isShowImpactHistoryWindow} close={() => {
                setShowImpactHistory(false)
            }}/>
            {showStatusChart && <StatusCharts/>}
        </div>
    )
})

